export const de = {
  common: {
    save: "Speichern",
    cancel: "Abbrechen",
    close: "Schließen",
    delete: "Löschen",
    edit: "Bearbeiten",
    create: "Erstellen",
    update: "Aktualisieren",
    loading: "Laden",
    error: "Fehler",
    saved: "Gespeichert",
    yes: "Ja",
    no: "Nein",
    all: "Alle",
    apply: "Anwenden",
    signOut: "Abmelden",
    confirm: "Bestätigen",
    optionalNotes: "Optionale Notizen",
    confirmDelete: "Löschen bestätigen",
    current: "Aktuell",
    ok: "OK",
    warning: "Warnung",
    success: "Erfolgreich",
    back: "Zurück",
    copied: "Kopiert",
    refresh: "Aktualisieren",
    add: "Hinzufügen",
    change: "Ändern",
    countryCode: "Ländervorwahl",
    none: "Keine",
  },

  auth: {
    login: "Anmelden",
    logout: "Abmelden",
    register: "Registrieren",
    email: "E-Mail",
    phone: "Telefon",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    firstName: "Vorname",
    lastName: "Nachname",
    accountName: "Kontoname",
    loginFailed: "Anmeldung fehlgeschlagen.",
    signInSubtitle: "Verwalten Sie Ihre Apartments, Buchungen und Gäste.",
    forgotPassword: "Passwort vergessen?",
    forgotPasswordSubtitle:
      "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen Anweisungen zum Zurücksetzen des Passworts.",
    sendResetLink: "Link zum Zurücksetzen senden",
    backToLogin: "Zurück zur Anmeldung",
    or: "oder",
    loginWithGoogle: "Mit Google fortfahren",
    loginWithFacebook: "Mit Facebook fortfahren",
    noAccount: "Sie haben noch kein Konto?",
    createAccount: "Konto erstellen",
    alreadyHaveAccount: "Sie haben bereits ein Konto?",
    registerSubtitle:
      "Erstellen Sie Ihr RentPilot-Konto und verwalten Sie Ihre Vermietungen.",
    verifyEmailBanner:
      "Bitte bestätigen Sie Ihre E-Mail-Adresse, bevor Sie alle RentPilot-Funktionen nutzen.",
    resendVerificationEmail: "E-Mail erneut senden",
    iVerified: "Ich habe bestätigt",
    resetPassword: "Passwort zurücksetzen",
    resetPasswordSubtitle:
      "Geben Sie ein neues Passwort für Ihr RentPilot-Konto ein.",
    newPassword: "Neues Passwort",
    invalidResetLink:
      "Der Link zum Zurücksetzen des Passworts ist ungültig oder unvollständig.",
  },

  tabs: {
    calendar: "Kalender",
    properties: "Objekte",
    statistics: "Statistiken",
    profile: "Profil",
    team: "Team",
    cleaners: "Team",
    support: "Support",
    cleaningTasks: "Aufgaben",
    invoices: "Rechnungen",
    menu: "Menü",
  },

  cleaners: {
    title: "Team",
    add: "Hinzufügen",
    cleaners: "Teammitglieder",
    newCleaner: "Neues Teammitglied",
    createCleaner: "Teammitglied erstellen",
    noCleaners: "Noch keine Teammitglieder.",
    schedule: "Zeitplan",
    noTasks: "Keine Reinigungsaufgaben.",
    assignCleaner: "Teammitglied zuweisen",
    cleanedHistory: "Reinigungshistorie",
    noCleanedHistory: "Noch keine gereinigten Einheiten.",
    failedCreateCleaner: "Teammitglied konnte nicht erstellt werden.",
    deleteQuestion: "{{name}} löschen?",
    description:
      "Verwalten Sie Teammitglieder und ihren Zugriff auf die Anwendung.",
    teamAccess: "Teamzugriff",
    members: "Mitglieder",
    addMemberDescription:
      "Fügen Sie einen Manager, Betrachter oder eine Reinigungskraft zu Ihrem Konto hinzu.",
    roleOverview: "Rollenübersicht",
    managerDescription:
      "Kann Buchungen, Objekte, Gäste, Aufgaben und Teammitglieder verwalten.",
    viewerDescription: "Kann den Kalender ansehen, ohne Daten zu verwalten.",
    cleanerDescription: "Kann nur zugewiesene Reinigungsaufgaben sehen.",
  },

  cleaning: {
    myTasks: "Meine Aufgaben",
    today: "Heute",
    upcoming: "Bevorstehend",
    done: "Erledigt",
    noTasksToday: "Keine Aufgaben für heute.",
    noUpcomingTasks: "Keine bevorstehenden Aufgaben.",
    noDoneTasks: "Keine abgeschlossenen Aufgaben.",
    scheduled: "Geplant",
    cleanedAt: "Gereinigt am",
    assignedTo: "Zugewiesen an",
    unassigned: "Nicht zugewiesen",
    start: "Start",
    markCleaned: "Als gereinigt markieren",
    futureTaskCannotBeCompleted:
      "Diese Aufgabe kann erst am geplanten Tag abgeschlossen werden.",
    status: {
      pending: "Ausstehend",
      in_progress: "In Bearbeitung",
      done: "Erledigt",
      cancelled: "Storniert",
    },
    description:
      "Heutige Aufgaben, kommende Reinigungen und abgeschlossene Reinigungshistorie anzeigen.",
  },

  calendar: {
    unit: "Einheit",
    noUnits: "Keine Einheiten",
    filters: "Filter",
    startDate: "Startdatum",
    endDate: "Enddatum",
    thisWeek: "Diese Woche",
    twoWeeks: "Zwei Wochen",
    threeWeeks: "Drei Wochen",
    thisMonth: "Dieser Monat",
    occupied: "Belegt",
    unavailable: "Nicht verfügbar",
    rangeOverlaps:
      "Der ausgewählte Zeitraum überschneidet sich mit einer bestehenden Buchung.",
    occupiedCellMessage:
      "Diese Einheit hat an dem ausgewählten Datum bereits eine Buchung.",
    selectCheckIn: "Check-in auswählen",
    selectCheckOut: "Check-out auswählen",
    clear: "Löschen",
    multi: "Mehrfach",
    single: "Einzeln",
    next7Days: "Nächste 7 Tage",
    next14Days: "Nächste 14 Tage",
    selectedStart: "Ausgewählter Start",
    tapCheckoutDate:
      "Tippen Sie auf das Check-out-Datum, um eine Buchung zu erstellen",
    subtitle: "Übersicht über Einheiten, Buchungen, Zahlungen und Reinigungen.",
    available: "Verfügbar",
    addObjects: "Objekte hinzufügen",
    addObjectsDescription:
      "Erstellen Sie Ihre erste Unterkunft und Einheit, um Reservierungen zu verwalten.",
    month: "Monat",
    next: "Weiter",
    allUnits: "Alle Apartments",
    checkInAfter: "Check-in ab 14:00",
    checkOutBefore: "Check-out bis 10:00",
    cleaning: "Reinigung",
    private: "Privat",
    closed: "Geschlossen",
    today: "Heute",
    fullYear: "Ganzes Jahr",
    availableDates: "Freie Termine",
    availableDatesByUnit: "Freie Termine nach Apartment",
    shown: "angezeigt",
    terms: "Termine",
    noFreePeriods: "Keine freien Termine",
  },

  booking: {
    newBooking: "Neue Buchung",
    bookingDetails: "Buchungsdetails",
    guestFirstName: "Vorname des Gastes",
    guestLastName: "Nachname des Gastes",
    guest: "Gast",
    phone: "Telefon",
    email: "E-Mail",
    unit: "Einheit",
    checkIn: "Check-in",
    checkOut: "Check-out",
    nights: "Nächte",
    pricePerNight: "Preis pro Nacht",
    total: "Gesamt",
    status: "Status",
    payment: "Zahlung",
    paymentStatus: "Zahlungsstatus",
    unpaid: "Unbezahlt",
    deposit: "Anzahlung",
    paid: "Bezahlt",
    reserved: "Reserviert",
    checkedIn: "Eingecheckt",
    checkedOut: "Ausgecheckt",
    cancelled: "Storniert",
    notes: "Notizen",
    createBooking: "Buchung erstellen",
    failedCreate: "Buchung konnte nicht erstellt werden.",
    guestFirstNamePlaceholder: "Max",
    guestLastNamePlaceholder: "Mustermann",
    phonePlaceholder: "+387...",
    emailPlaceholder: "max@example.com",
    pricePlaceholder: "45",
    arrivingAround: "Ankunft gegen 18:00",
    currency: "Währung",
    dateRange: "Aufenthaltsdaten",
    selectDates: "Daten auswählen",
    selectCheckIn: "Check-in-Datum auswählen",
    selectedDateOccupied: "Dieses Datum ist bereits belegt.",
    selectedRangeOverlaps:
      "Die ausgewählten Daten überschneiden sich mit einer bestehenden Buchung.",
    numberOfGuests: "Gäste",
    checkoutAfterCheckin: "Check-out muss nach dem Check-in liegen.",
    contactGuest: "Gast kontaktieren",
    invoice: "Rechnung",
    whatsapp: "WhatsApp",
    missingEmail: "Dieser Gast hat keine E-Mail-Adresse.",
    missingPhone: "Dieser Gast hat keine Telefonnummer.",
    noContactInfo: "Dieser Gast hat keine E-Mail-Adresse oder Telefonnummer.",
    confirmSendInvoice: "Rechnung an diesen Gast senden?",
    invoiceSent: "Rechnung gesendet.",
    failedSendInvoice: "Rechnung konnte nicht gesendet werden.",
    booking: "Buchung",
    editBooking: "Buchung bearbeiten",
    saveBooking: "Buchung speichern",
    sendInvoice: "Rechnung senden",
    cancelBooking: "Buchung stornieren",
    cancelBookingQuestion: "Möchten Sie diese Buchung wirklich stornieren?",
    bookingCreated: "Buchung erstellt.",
    bookingUpdated: "Buchung aktualisiert.",
    bookingCancelled: "Buchung storniert.",
    failedUpdate: "Buchung konnte nicht aktualisiert werden.",
    failedCancel: "Buchung konnte nicht storniert werden.",
    unitMissing: "Einheit fehlt.",
    emailUnavailable: "E-Mail ist nicht verfügbar.",
    emailSubject: "Reservierungsinformationen",
    emailBody: "Hallo, hier sind Ihre Reservierungsdetails.",
    whatsappMessage: "Hallo, hier sind Ihre Reservierungsdetails.",
    missingGuestEmail: "E-Mail des Gastes fehlt.",
    confirmSendInvoiceMessage:
      "Die Rechnung wird an die E-Mail-Adresse des Gastes gesendet.",
    checked_in: "Eingecheckt",
    checked_out: "Ausgecheckt",
  },

  bookingMessages: {
    title: "WhatsApp-Nachricht",
    templateOne:
      "Hallo {{guest}}, Ihre Reservierung für {{unit}} ist vom {{checkIn}} bis {{checkOut}} bestätigt.",
    templateTwo:
      "Hallo {{guest}}, vielen Dank für Ihre Reservierung. Check-in ist am {{checkIn}} und Check-out am {{checkOut}}.",
    templateThree:
      "Hallo {{guest}}, wir freuen uns auf Ihren Aufenthalt in {{unit}}. Ihre Daten sind {{checkIn}} - {{checkOut}}.",
    templateButton: "Vorlage {{number}}",
    customPlaceholder: "Nachricht schreiben...",
    openWhatsApp: "WhatsApp öffnen",
    customMessage: "Eigene Nachricht",
    invalidPhone: "Ungültige Telefonnummer.",
    missingPhone: "Telefonnummer fehlt.",
    whatsappUnavailable: "WhatsApp ist nicht verfügbar.",
  },

  properties: {
    title: "Objekte",
    newProperty: "Neues Objekt",
    createProperty: "Objekt erstellen",
    propertyName: "Objektname",
    address: "Adresse",
    city: "Stadt",
    notes: "Notizen",
    noUnits: "Noch keine Einheiten",
    units: "Einheiten",
    newUnit: "Neue Einheit",
    createUnit: "Einheit erstellen",
    unitName: "Name der Einheit",
    type: "Typ",
    capacity: "Kapazität",
    defaultPricePerNight: "Standardpreis pro Nacht",
    noDefaultPrice: "Kein Standardpreis",
    guests: "Gäste",
    disable: "Deaktivieren",
    enable: "Aktivieren",
    deleteProperty: "Objekt löschen",
    deletePropertyQuestion:
      "{{name}} löschen? Das funktioniert nur, wenn keine Buchungshistorie vorhanden ist.",
    deleteUnit: "Einheit löschen",
    deleteUnitQuestion:
      "Diese Einheit löschen? Wenn Buchungshistorie vorhanden ist, können Sie sie stattdessen deaktivieren.",
    failedCreateProperty: "Objekt konnte nicht erstellt werden.",
    failedCreateUnit: "Einheit konnte nicht erstellt werden.",
    apartment: "Apartment",
    room: "Zimmer",
    studio: "Studio",
    house: "Haus",
    other: "Sonstiges",
    newPropertyPlaceholder: "Sarajevo Apartments",
    addressPlaceholder: "Straße 1",
    cityPlaceholder: "Sarajevo",
    notesPlaceholder: "Optionale Notizen",
    unitNamePlaceholder: "Apartment A",
    pricePlaceholder: "45",
    capacityPlaceholder: "2",
    pricePerNightShort: "{{price}} / Nacht",
    deletePropertySuccess: "Objekt gelöscht.",
    deleteUnitSuccess: "Einheit gelöscht.",
    addUnit: "Einheit hinzufügen",
    activeUnits: "aktive Einheiten",
    inactiveUnits: "inaktive Einheiten",
    calendarSync: "Kalendersynchronisierung",
    calendarSyncHelp:
      "Füge hier Airbnb- und Booking.com-iCal-Exportlinks ein. RentPilot importiert diese Kalender und blockiert passende Daten.",
    airbnbIcalLink: "Airbnb iCal-Link",
    bookingIcalLink: "Booking.com iCal-Link",
    rentPilotExportLink: "RentPilot Export-Link",
    rentPilotExportCalendar: "RentPilot Export-Kalender",
    rentPilotExportHelp:
      "Kopiere diesen Link in Airbnb und Booking.com, damit dort RentPilot-Daten blockiert werden können.",
    rentPilotExportHelpLong:
      "Füge diesen Link in den externen Kalender-Einstellungen von Airbnb oder Booking.com ein.",
    airbnbConnected: "Airbnb verbunden",
    airbnbNotConnected: "Airbnb nicht verbunden",
    bookingConnected: "Booking.com verbunden",
    bookingNotConnected: "Booking.com nicht verbunden",
    noExternalCalendarsConnected: "Keine externen Kalender verbunden.",
    copyShareExportLink: "Export-Link kopieren",
    exportLinkMissing:
      "Export-Link fehlt. Das Backend hat calendar_export_url für diese Einheit nicht zurückgegeben.",
    exportLinkCopied: "Export-Link kopiert.",
    editUnit: "Einheit bearbeiten",
    saveUnit: "Einheit speichern",
    noUnitsDescription:
      "Fügen Sie Zimmer/Apartments hinzu, damit Buchungen und Reinigungsaufgaben dieser Unterkunft zugeordnet werden können.",
    activateUnit: "Einheit aktivieren",
    deactivateUnit: "Einheit deaktivieren",
    failedDeleteProperty: "Unterkunft konnte nicht gelöscht werden.",
    failedDeleteUnit: "Einheit konnte nicht gelöscht werden.",
    failedUpdateUnit: "Einheit konnte nicht aktualisiert werden.",
  },

  statistics: {
    title: "Statistiken",
    revenue: "Umsatz",
    bookings: "Buchungen",
    nights: "Nächte",
    averageBooking: "Durchschnittliche Buchung",
    breakdown: "Aufschlüsselung",
    noStatistics: "Keine Statistiken für die ausgewählten Filter.",
    groupBy: "Gruppieren nach",
    unit: "Einheit",
    property: "Objekt",
    month: "Monat",
    payment: "Zahlung",
    sevenDays: "7 Tage",
    fourteenDays: "14 Tage",
    thirtyDays: "30 Tage",
    thisMonth: "Dieser Monat",
    allProperties: "Alle Objekte",
    allUnits: "Alle Einheiten",
    byUnit: "Nach Einheit",
    byProperty: "Nach Objekt",
    byMonth: "Nach Monat",
    netProfit: "Nettogewinn",
    occupancy: "Auslastung",
    profitMargin: "Gewinnmarge",
    expenseRatio: "Kostenquote",
    revenueByUnit: "Umsatz nach Einheit",
    revenueByApartment: "Umsatz nach Apartment",
    noRevenueForPeriod: "Kein Umsatz im ausgewählten Zeitraum.",
    noExpensesForPeriod: "Keine Ausgaben im ausgewählten Zeitraum.",
    manualVsRecurringExpenses: "Einmalige vs. wiederkehrende Ausgaben",
    cashflow: "Cashflow",
    latestNetProfit: "Letzter Nettogewinn: {{amount}}",
    performanceBreakdown: "Leistungsübersicht",
    breakdownMeta: "{{bookings}} Buchungen · {{nights}} Nächte",
    margin: "Marge",
    revenueExpensesHint: "{{revenue}} Umsatz · {{expenses}} Ausgaben",
    expenses: "Ausgaben",
    expensesByCategory: "Ausgaben nach Kategorie",
    filters: "Filter",
  },

  expenses: {
    expenses: "Ausgaben",
    newExpense: "Neue Ausgabe",
    editExpense: "Ausgabe bearbeiten",
    newRecurringExpense: "Neue wiederkehrende Ausgabe",
    editRecurringExpense: "Wiederkehrende Ausgabe bearbeiten",
    manualExpenses: "Einmalige Ausgaben",
    recurringExpenses: "Wiederkehrende Ausgaben",
    totalExpenses: "Gesamtausgaben",
    noExpenses: "Noch keine Ausgaben.",
    noRecurringExpenses: "Noch keine wiederkehrenden Ausgaben.",
    name: "Name",
    category: "Kategorie",
    categoryPlaceholder: "Reinigung, Nebenkosten, Wartung...",
    amount: "Betrag",
    date: "Datum",
    frequency: "Häufigkeit",
    monthly: "Monatlich",
    yearly: "Jährlich",
    interval: "Intervall",
    dayOfMonth: "Tag des Monats",
    startDate: "Startdatum",
    endDate: "Enddatum",
    active: "Aktiv",
    inactive: "Inaktiv",
    noProperty: "Kein Objekt",
    noUnit: "Keine Einheit",
    uncategorized: "Ohne Kategorie",
    expensesByCategory: "Ausgaben nach Kategorie",
    expensesByType: "Ausgaben nach Typ",
    expensesByUnit: "Ausgaben nach Einheit",
    addExpense: "Ausgabe hinzufügen",
    oneTimeExpense: "Einmalige Ausgabe",
    oneTimeExpenseDescription:
      "Für einzelne Kosten wie Reparaturen, Handtücher oder einen einmaligen Kauf.",
    recurringExpense: "Wiederkehrende Ausgabe",
    recurringExpenseDescription:
      "Für wiederholte Kosten wie Internet, Abonnements oder monatliche Vorräte.",
  },

  profile: {
    title: "Profil",
    firstName: "Vorname",
    lastName: "Nachname",
    phone: "Telefon",
    saveProfile: "Profil speichern",
    profileUpdated: "Profil aktualisiert.",
    updateEmail: "E-Mail aktualisieren",
    currentPassword: "Aktuelles Passwort",
    emailUpdated: "E-Mail aktualisiert.",
    password: "Passwort",
    newPassword: "Neues Passwort",
    confirmNewPassword: "Neues Passwort bestätigen",
    updatePassword: "Passwort aktualisieren",
    passwordUpdated: "Passwort aktualisiert.",
    passwordsDoNotMatch:
      "Neues Passwort und Bestätigung stimmen nicht überein.",
    language: "Sprache",
    signOutQuestion: "Sind Sie sicher, dass Sie sich abmelden möchten?",
    failedProfileUpdate: "Profil konnte nicht aktualisiert werden.",
    failedEmailUpdate: "E-Mail konnte nicht aktualisiert werden.",
    failedPasswordUpdate: "Passwort konnte nicht aktualisiert werden.",
    email: "E-Mail",
    emailPlaceholder: "email@example.com",
    phonePlaceholder: "+387...",
    firstNamePlaceholder: "Vorname",
    lastNamePlaceholder: "Nachname",
    currentPasswordPlaceholder: "Aktuelles Passwort",
    newPasswordPlaceholder: "Neues Passwort",
    confirmNewPasswordPlaceholder: "Neues Passwort bestätigen",
    signOut: "Abmelden",
    currencySettings: "Währung",
  },

  currency: {
    currency: "Währung",
    currencyUpdated: "Währung aktualisiert",
    defaultCurrency: "Standardwährung",
    bam: "KM",
    eur: "€",
    usd: "$",
    rsd: "RSD",
    failedCurrencyUpdate: "Währung konnte nicht aktualisiert werden.",
  },

  support: {
    title: "Support",
    needSupport: "Brauchen Sie Hilfe?",
    description:
      "Kontaktieren Sie uns, wenn Sie Hilfe mit Ihrem Konto, Buchungen, Objekten, Team oder Abonnement benötigen.",
    callSupport: "Support anrufen",
    emailSupport: "Support per E-Mail kontaktieren",
  },

  subscription: {
    title: "Abonnement",
    subtitle: "Wählen Sie den Plan, der zu Ihrer Vermietung passt.",
    currentPlan: "Aktueller Plan",
    freeNotice: "Sie nutzen derzeit den kostenlosen Plan.",
    perMonth: "/ Monat",
    choosePlan: "Plan auswählen",
    manageBilling: "Abrechnung verwalten",
    upgradeRequired: "Upgrade erforderlich",
    upgradeRequiredMessage:
      "Das Limit Ihres aktuellen Plans wurde erreicht. Bitte aktualisieren Sie Ihr Abonnement.",
    accessWarningTitle: "Der RentPilot-Zugriff läuft bald ab",

    accessWarningMessage:
      "Ihr RentPilot-Zugriff läuft am {{date}} ab. Wählen oder verlängern Sie vorher einen Tarif, damit Sie weiterhin Daten erstellen und ändern können.",

    customAccessWarningMessage:
      "Ihr individueller RentPilot-Tarif läuft am {{date}} ab. Kontaktieren Sie den RentPilot-Support und vereinbaren Sie vorher die Zahlung, um die App weiter nutzen zu können.",

    accessExpiredTitle: "Der RentPilot-Zugriff ist eingeschränkt",

    accessExpiredMessage:
      "Ihr Abonnement ist abgelaufen oder wurde nicht bezahlt. Vorhandene Daten können weiterhin angezeigt werden, das Erstellen und Ändern von Daten ist jedoch bis zur Zahlung deaktiviert.",

    customAccessExpiredMessage:
      "Ihr individueller RentPilot-Tarif ist abgelaufen oder wurde nicht bezahlt. Vorhandene Daten können weiterhin angezeigt werden, das Erstellen und Ändern von Daten ist jedoch deaktiviert. Kontaktieren Sie den RentPilot-Support, um die Zahlung zu vereinbaren und den Zugriff wiederherzustellen.",

    contactAccountOwnerMessage:
      "Kontaktieren Sie den Kontoinhaber, damit die Zahlung vereinbart und der vollständige Zugriff wiederhergestellt wird.",

    viewPlansCta: "Tarife anzeigen",

    contactSupportCta: "Support kontaktieren",

    noticeCloseCta: "Verstanden",
    billingPeriod: "Abrechnungszeitraum",
    trialExpiresSoonBanner:
      "Ihre Testphase läuft in {{hours}} Stunden ab. Um RentPilot weiter zu nutzen, wählen Sie einen Tarif in der Web-App.",
    trialExpiresSoonCta: "Tarif wählen",
    billingPeriodDescription:
      "Wählen Sie aus, für wie viele Monate Sie im Voraus bezahlen möchten.",
    planColumn: "Paket",
    limitColumn: "Limit",
    priceColumn: "Preis",
    discountColumn: "Rabatt",
    featuresColumn: "Enthalten",
    actionColumn: "Aktion",
    recommended: "Empfohlen",
    discountBadge: "{{discount}}% Rabatt",
  },

  menu: {
    pricing: "Preise",
    pricingDescription:
      "Sehen Sie Ihren aktuellen Plan und Ihre Abrechnungsoptionen.",
    currentPlan: "Aktueller Plan",
    pricingComingSoon: "Die vollständige Preisverwaltung wird hier verbunden.",
    myAccount: "Mein Konto",
    myAccountDescription: "Profil, E-Mail und Passwort.",
    support: "Support",
    supportDescription: "Support kontaktieren oder Hilfeinformationen ansehen.",
    settings: "Einstellungen",
    settingsDescription: "Aussehen der App, Sprache und Währung",
    privacy: "Datenschutz & Unternehmensinformationen",
    privacyDescription:
      "Informationen zum Unternehmen, Kundenservice und Datenschutz.",
  },

  settings: {
    appAppearance: "Aussehen der App",
    fontSize: "Schriftgröße",
    fontSmall: "Klein",
    fontMedium: "Mittel",
    fontLarge: "Groß",
    fontVeryLarge: "Sehr groß",
    bookingColors: "Buchungsfarben",
    theme: "Design",
    themeSystem: "System",
    themeLight: "Hell",
    themeDark: "Dunkel",
  },

  roles: {
    role: "Rolle",
    owner: "Eigentümer",
    manager: "Manager",
    cleaner: "Zimmermädchen",
    viewer: "Beobachter",
    teamMember: "Teammitglied",
  },

  invoices: {
    title: "Gesendete Rechnungen",
    description: "Gesendete Rechnungen und E-Mail-Verlauf anzeigen.",
    emptyTitle: "Noch keine Rechnungen",
    empty: "Es wurden noch keine Rechnungen gesendet.",
    failedLoad: "Rechnungen konnten nicht geladen werden.",
    sentAt: "Gesendet am",
    status: {
      pending: "Ausstehend",
      sent: "Gesendet",
      failed: "Fehlgeschlagen",
    },
  },
  accountDeletion: {
    title: "Brisanje računa",
    description:
      "Ovim šaljete zahtjev za trajno brisanje računa. Svi objekti, jedinice, rezervacije, gosti, članovi tima, fakture, zadaci čišćenja, troškovi i postavke povezane s ovim računom bit će obrisani.",
    warning:
      "Brisanje se zakazuje sa sigurnosnim odgodom, ali ovo koristite samo ako ste sigurni.",
    typeDelete: "Upišite DELETE za potvrdu brisanja računa.",
    requestDeletion: "Zatraži brisanje",
    alreadyScheduled: "Brisanje računa je već zakazano za {{date}}.",
    cancelInfo:
      "Zahtjev za brisanje možete otkazati prije zakazanog datuma brisanja.",
    cancelDeletion: "Otkaži zahtjev za brisanje",
    cancelQuestion: "Da li ste sigurni da želite otkazati zahtjev za brisanje?",
    scheduledMessage: "Brisanje računa je zakazano.",
    cancelledMessage: "Zahtjev za brisanje računa je otkazan.",
    failedRequest: "Nije moguće zatražiti brisanje računa.",
    failedCancel: "Nije moguće otkazati brisanje računa.",
  },

  merchant: {
    title: "Händlerinformationen",
    description:
      "Angaben zum Rechtsträger, der den RentPilot-Dienst bereitstellt und abrechnet.",
    legalName: "Vollständiger Firmenname",
    address: "Adresse",
    businessActivity: "Geschäftstätigkeit",
    activityCode: "Tätigkeitscode",
    registrationNumber: "Registrierungsnummer",
    taxNumber: "Steuer- / JIB-Nummer",
    website: "Webseite",
    phone: "Kontakttelefon",
    email: "Kontakt-E-Mail",

    customerServiceTitle: "Kundenservice",
    customerServiceDescription:
      "Für Informationen zu Bestellungen und Zahlungen, Beschwerden, Kündigungen und andere Anfragen können Sie uns über die unten angegebenen Kontaktdaten erreichen.",

    privacyTitle: "Datenschutz",
    privacyDescription:
      "RentPilot erhebt nur Daten, die für die Bereitstellung des Dienstes, die Verwaltung von Benutzerkonten, die Bearbeitung von Bestellungen und Zahlungen, den Kundensupport und die Erfüllung gesetzlicher Verpflichtungen erforderlich sind. Personenbezogene Daten werden nicht verkauft. Die Daten sind nur autorisierten Personen und Dienstleistern zugänglich, die sie zur Erfüllung ihrer Aufgaben benötigen. Kartendaten werden ausschließlich auf der geschützten Seite des Zahlungsdienstleisters eingegeben und sind für das RentPilot-System weder zugänglich noch werden sie dort gespeichert.",
  },
};
